import { Fragment } from 'react';

import Typo from '@/components/Typography/Typo';
import FeedbackBlockTooltip from '@/features/Feedback/components/FeedbackBlockTooltip/FeedbackBlockTooltip';
import useFeedbackBlockTooltip from '@/features/Feedback/components/FeedbackBlockTooltip/useFeedbackBlockTooltip';
import { ContentStyle } from '@/styles/ContentStyle';

import feedbackDetailUtils from '../../utils/feedbackDetailutils';

type Props = {
  detail: FeedbackT;
  focusedBlock?: string;
};

export const SurveyDisplay = (props: Props) => {
  const survey = props.detail.survey;

  return (
    <div className="flex flex-col gap-3">
      {survey?.items.map((item) => (
        <SurveyItem
          key={item.id}
          item={item}
          detail={props.detail}
          focusedBlock={props.focusedBlock}
        />
      ))}
    </div>
  );
};

const SurveyItem = (props: {
  item: SurveyItem;
  detail: FeedbackT;
  focusedBlock?: string;
}) => {
  const { tooltipInfo, currentBlockInfo, onMouseMove, onMouseLeave } =
    useFeedbackBlockTooltip({
      blocks: props.detail.blocks || [],
    });

  return (
    <div className="flex flex-col gap-2 py-2.5 px-3 border border-gray-300 rounded-lg hover:bg-gray-150 hover:border-gray-300">
      <Typo type="body3" weight="r" className="text-gray-600">
        {props.item.question}
      </Typo>
      <div className="flex flex-col gap-1">
        {props.item.answers?.map((answer) => {
          if (!answer.value)
            return (
              <Fragment key={answer.id}>
                <Typo type="body3" weight="r" className="text-gray-600">
                  -
                </Typo>
              </Fragment>
            );
          const textHTML = feedbackDetailUtils
            .setBlockTags({
              text: answer.value,
              blocks: props.detail.blocks || [],
              source_id: answer.id,
              focusedBlock: props.focusedBlock,
            })
            .replaceAll('\n', '<br/>');

          return (
            <Fragment key={answer.id}>
              <ContentStyle
                dangerouslySetInnerHTML={{ __html: textHTML }}
                onMouseLeave={onMouseLeave}
                onMouseMove={onMouseMove}
              />
              <FeedbackBlockTooltip
                tooltipInfo={tooltipInfo}
                currentBlockInfo={currentBlockInfo}
              />
            </Fragment>
          );
        })}
      </div>
    </div>
  );
};
